import React, { useState } from "react";
import "./ClientDetails.css";
import ModalWrap from "../../../Components/ModalWrap/ModalWrap";
import CloseIcon from "../../../../assets/images/admin-dashboard/modal-close.svg";
import ClientInfo from "./ClientInfo/ClientInfo";
import PersonalInfo from "./PersonalInfo/PersonalInfo";
import DependentInfo from "./Dependents/Dependents";
import BankDetails from "./BankDetails/BankDetails";
import FBAR from "./FBAR/FBAR";
import OtherIncome from "./OtherIncome/OtherIncome";
import Expenses from "./Expenses/Expenses";
import RentalIncome from "./RentalIncome/RentalIncome";
import Referrals from "./Referrals/Referrals";
import TaxSummary from "./TaxSummary/TaxSummary";
import UploadDocuments from "./UploadDocuments/UploadDocuments";

const ClientDetails = ({ open, handleClose }) => {
  const [activeOption, setActionOption] = useState("clientsInfo");
  const [activePage, setActivePage] = useState("clientsInfo");
  const handleActivePage = (page) => {
    setActivePage(page);
  };
  return (
    <ModalWrap open={open} handleClose={handleClose} maxWidth="1640px">
      <div className="clientdetails__modal_wrap">
        <div className="clientdetails__modal_header">
          <div className="clientdetails__modal_hdrleft">Client Details</div>
          <div className="clientdetails__modal_hdrright">
            <div
              className="clientdetails__modal_closebtn"
              onClick={handleClose}
            >
              <img
                src={CloseIcon}
                alt=""
                className="clientdetails__modal_closebtnicn"
              />
            </div>
          </div>
        </div>
        <div className="clientdetails__modal_options">
          <div
            className={`clientdetails__modal_option ${
              activeOption === "clientsInfo"
                ? "clientdetails__modal_optionactive"
                : ""
            }`}
            onClick={() => {
              setActionOption("clientsInfo");
              setActivePage("clientsInfo");
            }}
          >
            Clients Info
          </div>
          <div
            className={`clientdetails__modal_option ${
              activeOption === "clientsDocument"
                ? "clientdetails__modal_optionactive"
                : ""
            }`}
            onClick={() => {
              setActionOption("clientsDocument");
              setActivePage("personalInfo");
            }}
          >
            Clients Document
          </div>
        </div>
        {activeOption === "clientsInfo" && <ClientInfo />}
        {activeOption === "clientsDocument" && (
          <div className="cdclients__document_navigation">
            <div
              className={`${
                activePage === "personalInfo"
                  ? "cdclients__document_navitemactive"
                  : "cdclients__document_navitem"
              } `}
              onClick={() => handleActivePage("personalInfo")}
            >
              Personal Info
            </div>
            <div
              className={`${
                activePage === "dependents"
                  ? "cdclients__document_navitemactive"
                  : "cdclients__document_navitem"
              } `}
              onClick={() => handleActivePage("dependents")}
            >
              Dependents
            </div>
            <div
              className={`${
                activePage === "bank_details"
                  ? "cdclients__document_navitemactive"
                  : "cdclients__document_navitem"
              } `}
              onClick={() => handleActivePage("bank_details")}
            >
              Bank Details
            </div>
            <div
              className={`${
                activePage === "fbar"
                  ? "cdclients__document_navitemactive"
                  : "cdclients__document_navitem"
              } `}
              onClick={() => handleActivePage("fbar")}
            >
              FBAR
            </div>
            <div
              className={`${
                activePage === "other_income"
                  ? "cdclients__document_navitemactive"
                  : "cdclients__document_navitem"
              } `}
              onClick={() => handleActivePage("other_income")}
            >
              Other Income
            </div>
            <div
              className={`${
                activePage === "expenses"
                  ? "cdclients__document_navitemactive"
                  : "cdclients__document_navitem"
              } `}
              onClick={() => handleActivePage("expenses")}
            >
              Expenses
            </div>
            <div
              className={`${
                activePage === "rental_income"
                  ? "cdclients__document_navitemactive"
                  : "cdclients__document_navitem"
              } `}
              onClick={() => handleActivePage("rental_income")}
            >
              Rental Income
            </div>
            <div
              className={`${
                activePage === "referrals"
                  ? "cdclients__document_navitemactive"
                  : "cdclients__document_navitem"
              } `}
              onClick={() => handleActivePage("referrals")}
            >
              Referrals
            </div>
            <div
              className={`${
                activePage === "tax_summary"
                  ? "cdclients__document_navitemactive"
                  : "cdclients__document_navitem"
              } `}
              onClick={() => handleActivePage("tax_summary")}
            >
              Tax Summary
            </div>
            <div
              className={`${
                activePage === "upload_docs"
                  ? "cdclients__document_navitemactive"
                  : "cdclients__document_navitem"
              } `}
              onClick={() => handleActivePage("upload_docs")}
            >
              Upload Docs
            </div>
          </div>
        )}
        {activePage === "personalInfo" && <PersonalInfo />}
        {activePage === "dependents" && <DependentInfo />}
        {activePage === "bank_details" && <BankDetails />}
        {activePage === "fbar" && <FBAR />}
        {activePage === "other_income" && <OtherIncome />}
        {activePage === "expenses" && <Expenses />}
        {activePage === "rental_income" && <RentalIncome />}
        {activePage === "referrals" && <Referrals />}
        {activePage === "tax_summary" && <TaxSummary />}
        {activePage === "upload_docs" && <UploadDocuments />}
      </div>
    </ModalWrap>
  );
};

export default ClientDetails;
